import { CssBaseline, Theme, useMediaQuery } from '@mui/material'
import Copyright from 'components/Copyright'
import React, { useState } from 'react'
import { Navigate } from 'react-router'
import { AppTemplateActions, AppTemplateStoreStates } from '.'
import EmailVerification from './EmailVerification'
import Header from './Header'
import Navigator from './Navigator'
import { App, AppMain, AppTemplateContainer, Drawer, drawerWidth, Footer } from './styles'

type AppTemplateProps = React.PropsWithChildren<AppTemplateStoreStates & AppTemplateActions>

const AppTemplate = (props: AppTemplateProps) => {
  const { children, auth, logOut, sendVerificationEmail } = props
  const { user } = auth
  const isEditor = user?.isEditor || false
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'))
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  if (!user) {
    return <Navigate replace to="/login" />
  }

  if (!user.isEmailVerified) {
    return <EmailVerification auth={auth} onResend={() => sendVerificationEmail()} onLogOut={() => logOut()} />
  }

  return (
    <AppTemplateContainer>
      <CssBaseline />
      <Drawer>
        {!smUp && (
          <Navigator
            variant="temporary"
            open={isMenuOpen}
            isEditor={isEditor}
            slotProps={{
              paper: {
                style: { width: drawerWidth },
              },
            }}
            onClose={() => setIsMenuOpen(!isMenuOpen)}
            onMenuClick={() => setIsMenuOpen(!isMenuOpen)}
          />
        )}
        {!mdDown && (
          <Navigator
            isEditor={isEditor}
            slotProps={{
              paper: {
                style: { width: drawerWidth },
              },
            }}
          />
        )}
      </Drawer>
      <App>
        <Header name={user.name} onDrawerToggle={() => setIsMenuOpen(!isMenuOpen)} onLogOut={() => logOut()} />
        <AppMain>{children}</AppMain>
        <Footer>
          <Copyright />
        </Footer>
      </App>
    </AppTemplateContainer>
  )
}

export default AppTemplate
